import React, { createRef, useState } from 'react';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import Select from 'components/Select';
import { useDispatch } from 'react-redux';
import Button from 'components/Button';
import { CSVReader } from 'react-papaparse';
import GenerateInvoiceModal from 'pages/printify-invoices/GenerateInvoiceModal';
import InvoiceTable from 'pages/printify-invoices/InvoiceTable';
import {
  linxOrderPrintifyDataUS,
  linxOrderPrintifyEventDataUS,
  linxStockProdDataUS,
  linxStockProdDataCA,
  linxOrderPrintifyEventDataCA,
  linxOrderPrintifyDataCA,
  machineOrderDetails,
} from 'actions/orders';
import { Title, TableWrapper } from 'styles/pages/printify-invoices';
import {
  productionItemsInitiate,
  shippingItemsInitiate,
  productionNewItemsInitiate,
  getShipCost,
  getFleeceShipCost,
  getPrintifyDetails,
} from 'pages/printify-invoices/data';
const XMLParser = require('react-xml-parser');

const buttonRef = createRef();
const productionBtnRef = createRef();
const shippingBtnRef = createRef();
const craReportBtnRef = createRef();
const productionNewBtnRef = createRef();

const PrintifyInvoices = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  const [productionCSVData, setProductionCSVData] = useState([]);
  const [productionNewCSVData, setProductionNewCSVData] = useState([]);
  const [shippingCSVData, setShippingCSVData] = useState([]);
  const [craReportData, setCraReportData] = useState([]);
  const [country, setCountry] = useState('CA');

  const [modal, setModal] = useState(false);
  const [currentOrderIndex, setCurrentOrderIndex] = useState(0);
  const [month, setMonth] = useState('');
  const handleOpenDialog = (e) => {
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  const handleOnFileLoad = (data) => {
    if (data?.length) {
      let result = [];

      for (let i = 1; i < data?.length; i++) {
        const row = data[i]?.data;

        if (row?.length > 2) {
          result.push({
            date: row[1],
            orderNumber: row[0],
            source: row[2],
          });
        }
      }

      setData(result);
    }
  };

  const handleOnError = (err, file, inputElem, reason) => {
    alert(err);
  };

  const generateCRAFile = async () => {
    let usOrders = [['Order Number', 'Country', 'Amount']];
    for (let i = 0; i < data.length; i++) {
      if (usOrders?.length === 11) {
        break;
      }

      const element = data[i];
      const machineStatusData = await dispatch(
        machineOrderDetails({
          PrintProvider: country,
          orderPo: element?.orderNumber,
          source: element?.source,
        })
      );
      const json = new XMLParser().parseFromString(
        machineStatusData?.string?._text
      );

      const { children } = json || {};

      const requestChildren = children?.find(
        (c) => c?.name === 'Request'
      )?.children;

      const orderNumber = requestChildren?.find((c) => c?.name === 'PO')?.value;

      const shipToChildren = requestChildren?.find(
        (c) => c?.name === 'ShipTo'
      )?.children;

      const orderCountry = shipToChildren?.find(
        (c) => c?.name === 'Country'
      )?.value;

      if (orderCountry === 'US') {
        usOrders.push([orderNumber, orderCountry, '']);
      }
    }

    setCraReportData(usOrders);

    setTimeout(() => {
      craReportBtnRef.current?.link?.click();
    }, 0);
  };

  const generateInvoice = async () => {
    let shippingItems = _.clone(shippingItemsInitiate);
    let productionItems = _.clone(productionItemsInitiate);
    let productionNewItems = _.clone(productionNewItemsInitiate);
    setModal(true);

    for await (let order of data) {
      setCurrentOrderIndex((state) => state + 1);

      await new Promise(async (resolve) => {
        const orderInfo = await dispatch(
          country === 'US'
            ? linxOrderPrintifyDataUS(order?.orderNumber)
            : linxOrderPrintifyDataCA(order?.orderNumber)
        );

        const {
          id,
          reference_id,
          items,
          address_to: {
            first_name,
            last_name,
            city,
            region,
            zip,
            country: orderCountry,
          },
        } = orderInfo;

        const fleeceSearch = items?.find(
          (el) =>
            el.sku.split('-')[1] == '18500' ||
            el.sku.split('-')[1] == '18500B' ||
            el.sku.split('-')[1] == '18600'
        );
        let shipCost;

        if (fleeceSearch) {
          shipCost = getFleeceShipCost(orderInfo, country);
        } else {
          shipCost = getShipCost(orderInfo, country);
        }

        const printifyInfo = await dispatch(
          country === 'US'
            ? linxOrderPrintifyEventDataUS(order?.orderNumber)
            : linxOrderPrintifyEventDataCA(order?.orderNumber)
        );
        const { createDate, orderShippedDate, trackingNumber } =
          getPrintifyDetails(printifyInfo);
        const shipName = `${first_name} ${last_name}`;
        const dataToInsertInShipping = {
          invoice: id,
          order: reference_id,
          orderDate: createDate,
          shipDate: orderShippedDate,
          shipCost: `US$${shipCost.toFixed(2).toString().replace(/\./g, ',')}`,
          tax: '$0',
          trackingNumber: "'" + trackingNumber.toString(),
          shipName,
          shipCity: city,
          shipState: region,
          shipZip: zip,
          country: orderCountry,
          weight: '0,61',
        };
        shippingItems.push(dataToInsertInShipping);

        (async function () {
          for await (let item of items) {
            await new Promise((resolve) => {
              const { quantity, sku, print_files } = item;
              const skuSplit = sku?.split('-');
              const printFilesLength = Object.keys(print_files).length;

              (async function () {
                let productPrice = await dispatch(
                  country === 'US'
                    ? linxStockProdDataUS(
                        skuSplit[0] === 'Bella+Canvas'
                          ? sku?.replace(/\+/g, '%2B')
                          : sku
                      )
                    : linxStockProdDataCA(
                        skuSplit[0] === 'Bella+Canvas'
                          ? sku?.replace(/\+/g, '%2B')
                          : sku
                      )
                );

                if (!productPrice || Object.keys(productPrice)?.length == 0) {
                  productPrice = await dispatch(
                    country === 'US'
                      ? linxStockProdDataCA(
                          skuSplit[0] === 'Bella+Canvas'
                            ? sku?.replace(/\+/g, '%2B')
                            : sku
                        )
                      : linxStockProdDataUS(
                          skuSplit[0] === 'Bella+Canvas'
                            ? sku?.replace(/\+/g, '%2B')
                            : sku
                        )
                  );
                }

                const {
                  SkuStockItem: { BasePrice, PrintConfigurationName },
                } = productPrice || {
                  SkuStockItem: {
                    BasePrice: 8,
                    PrintConfigurationName: { _text: 'T-Shirt' },
                  },
                };
                const text = PrintConfigurationName._text;
                const productBasePrice = parseFloat(BasePrice._text).toFixed(2);
                let printCost = 0;
                let frontPrint = 0;
                let backPrint = 0;
                let productCost = 0;

                if (text == 'Bella+Canvas T-Shirt') {
                  if (printFilesLength == 1) {
                    printCost = 3.75;
                    frontPrint = 1 * quantity;
                    backPrint = backPrint;
                    productCost =
                      parseFloat(productBasePrice) + parseFloat(3.75);
                  } else if (printFilesLength == 2) {
                    printCost = 7.5;
                    frontPrint = 1 * quantity;
                    backPrint = 1 * quantity;
                    productCost =
                      parseFloat(productBasePrice) + parseFloat(7.5);
                  }
                } else if (
                  text == 'T-Shirt' ||
                  text == 'Youth T-Shirt' ||
                  text == 'Hoodie' ||
                  text == 'Long Sleeve'
                ) {
                  if (printFilesLength == 1) {
                    printCost = 3.75;
                    frontPrint = 1 * quantity;
                    backPrint = backPrint;
                    productCost =
                      parseFloat(productBasePrice) + parseFloat(3.75);
                  } else if (printFilesLength == 2) {
                    printCost = 7.5;
                    frontPrint = 1 * quantity;
                    backPrint = 1 * quantity;
                    productCost =
                      parseFloat(productBasePrice) + parseFloat(7.5);
                  }
                } else {
                  if (printFilesLength == 1) {
                    printCost = country === 'CA' ? 5.2 : 3.75;
                    frontPrint = 1 * quantity;
                    backPrint = backPrint;
                    productCost =
                      parseFloat(productBasePrice) + parseFloat(3.75);
                  }
                  if (printFilesLength == 2) {
                    printCost = country === 'CA' ? 10.4 : 7.5;
                    frontPrint = 1 * quantity;
                    backPrint = 1 * quantity;
                    productCost =
                      parseFloat(productBasePrice) + parseFloat(7.5);
                  }
                }

                const totalLineItemCost = (productCost * quantity).toFixed(2);

                productionItems.push({
                  order: reference_id,
                  invoice: id,
                  status: '',
                  orderDate: createDate,
                  shipDate: orderShippedDate,
                  itemQty: quantity,
                  blankCost: productBasePrice,
                  printCost: printCost,
                  printNumbers: printFilesLength,
                  tax: 0,
                  totalLineItemCost: totalLineItemCost,
                  numberCancelled: 0,
                  item: sku,
                  description: sku,
                  shipName,
                  shipCity: city,
                  shipState: region,
                  shipZip: zip,
                  country: country,
                  itemShort: sku,
                });

                productionNewItems.push({
                  ppOrder: id,
                  order: reference_id,
                  orderStatus: 'Shipped',
                  orderSku: sku,
                  shipSku: sku,
                  orderCreated: createDate,
                  orderShip: orderShippedDate,
                  itemQty: quantity,
                  blankCost: '$' + productBasePrice,
                  printCost: '$' + printCost,
                  frontPrint: frontPrint,
                  backPrint: backPrint,
                  sleevePrint: '',
                  innerLabel: '',
                  outerLabel: '',
                  handlingCost: '$0.00',
                  discount: '$0.00',
                  totalLineItemCost: '$' + totalLineItemCost,
                  taxRate: '0%',
                  tax: '$ - ',
                  totalCostwithTax: '$' + totalLineItemCost,
                  shipState: region,
                  country: country,
                  trackingNumber: "'" + trackingNumber,
                  shipstationShippingPrice: '',
                });
                resolve();
              })();
            });
          }
          resolve();
        })();
      });
    }

    if (shippingItems?.length) {
      let data = [];
      for (let i = 0; i < shippingItems?.length; i++) {
        const row = shippingItems[i];
        const {
          invoice,
          order,
          orderDate,
          shipDate,
          shipCost,
          tax,
          trackingNumber,
          shipName,
          shipCity,
          shipState,
          shipZip,
          country,
          weight,
        } = row;
        data.push([
          invoice,
          order,
          orderDate,
          shipDate,
          shipCost,
          tax,
          trackingNumber,
          shipName,
          shipCity,
          shipState,
          shipZip,
          country,
          weight,
        ]);
      }
      setShippingCSVData(data);

      setTimeout(() => {
        shippingBtnRef.current?.link?.click();
      }, 0);
    }

    if (productionItems?.length) {
      let data = [];
      for (let i = 0; i < productionItems?.length; i++) {
        const row = productionItems[i];
        const {
          invoice,
          order,
          orderDate,
          shipDate,
          tax,
          shipName,
          shipCity,
          shipState,
          shipZip,
          country,
          status,
          itemQty,
          blankCost,
          printCost,
          printNumbers,
          totalLineItemCost,
          numberCancelled,
          item,
          description,
          itemShort,
        } = row;
        data.push([
          order,
          invoice,
          status,
          orderDate,
          shipDate,
          itemQty,
          blankCost,
          printCost,
          printNumbers,
          tax,
          totalLineItemCost,
          numberCancelled,
          item,
          description,
          shipName,
          shipCity,
          shipState,
          shipZip,
          country,
          itemShort,
        ]);
      }
      setProductionCSVData(data);

      setTimeout(() => {
        productionBtnRef.current?.link?.click();
      }, 0);
    }

    if (productionNewItems?.length) {
      let data = [];
      for (let i = 0; i < productionNewItems?.length; i++) {
        const row = productionNewItems[i];
        const {
          ppOrder,
          order,
          orderStatus,
          orderSku,
          shipSku,
          orderCreated,
          orderShip,
          itemQty,
          blankCost,
          printCost,
          frontPrint,
          backPrint,
          sleevePrint,
          innerLabel,
          outerLabel,
          handlingCost,
          discount,
          totalLineItemCost,
          taxRate,
          tax,
          totalCostwithTax,
          shipState,
          country,
          trackingNumber,
          shipstationShippingPrice,
        } = row;
        data.push([
          ppOrder,
          order,
          orderStatus,
          orderSku,
          shipSku,
          orderCreated,
          orderShip,
          itemQty,
          blankCost,
          printCost,
          frontPrint,
          backPrint,
          sleevePrint,
          innerLabel,
          outerLabel,
          handlingCost,
          discount,
          totalLineItemCost,
          taxRate,
          tax,
          totalCostwithTax,
          shipState,
          country,
          trackingNumber,
          shipstationShippingPrice,
        ]);
      }
      setProductionNewCSVData(data);

      setTimeout(() => {
        productionNewBtnRef.current?.link?.click();
      }, 0);
    }

    setModal(false);
    setCurrentOrderIndex(0);
  };

  return (
    <React.Fragment>
      <Title>
        <div>Printify Invoices</div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: 20, width: 116 }}>
            <Select
              label="Select Country"
              options={['US', 'CA']}
              value={country}
              onChange={(v) => setCountry(v)}
            />
          </div>

          <div style={{ marginRight: 20, width: 150 }}>
            <Select
              label="Select Month"
              options={[
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
              ]}
              value={month}
              onChange={(v) => setMonth(v)}
            />
          </div>
          {month && (
            <CSVReader
              ref={buttonRef}
              onFileLoad={handleOnFileLoad}
              onError={handleOnError}
              noClick
              noDrag
              noProgressBar
            >
              {({ file }) => (
                <aside
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <button
                    type="button"
                    onClick={handleOpenDialog}
                    style={{
                      width: 100,
                      cursor: 'pointer',
                      background: '#000',
                      color: '#fff',
                      border: 'none',
                      fontWeight: 'bold',
                      minHeight: 35,
                    }}
                  >
                    Upload file
                  </button>
                  {file && (
                    <div
                      style={{
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: '#000',
                        textAlign: 'center',
                        minHeight: 35,
                        lineHeight: 2.5,
                        width: 200,
                        fontSize: 12,
                      }}
                    >
                      {file && file.name}
                    </div>
                  )}
                </aside>
              )}
            </CSVReader>
          )}

          {data && (
            <>
              <Button
                title="Generate Invoice"
                onClick={generateInvoice}
                containerStyle={{
                  marginLeft: 10,
                  padding: '5px 10px',
                }}
              />
              <Button
                title="CRA File"
                onClick={generateCRAFile}
                containerStyle={{
                  marginLeft: 10,
                  padding: '5px 10px',
                }}
              />
            </>
          )}
          <CSVLink
            style={{ display: 'none' }}
            ref={productionBtnRef}
            filename={`BOT_${country}-Printify(${month})-Production.csv`}
            data={productionCSVData}
          >
            Download me
          </CSVLink>

          <CSVLink
            style={{ display: 'none' }}
            ref={craReportBtnRef}
            filename={`BOT_${country}-CRA(${month})-Report.csv`}
            data={craReportData}
          >
            Download me
          </CSVLink>
          <CSVLink
            style={{ display: 'none' }}
            ref={shippingBtnRef}
            filename={`BOT_${country}-Printify(${month})-Shipping.csv`}
            data={shippingCSVData}
          >
            Download me
          </CSVLink>
          <CSVLink
            style={{ display: 'none' }}
            filename={`BOT_${country}-Printify(${month})-ProductionNew.csv`}
            ref={productionNewBtnRef}
            data={productionNewCSVData}
          >
            Download me
          </CSVLink>
        </div>
      </Title>
      {data && (
        <TableWrapper>
          <InvoiceTable data={data} />
        </TableWrapper>
      )}

      <GenerateInvoiceModal
        totalOrders={data?.length}
        open={modal}
        currentOrderIndex={currentOrderIndex}
      />
    </React.Fragment>
  );
};

export default PrintifyInvoices;
